import { createContext, useContext, ReactNode } from 'react'
import { useProcessJob, UseProcessJobReturn } from './useProcessJob'

const ProcessJobContext = createContext<UseProcessJobReturn | null>(null)

export function ProcessJobProvider({ children, onComplete }: { children: ReactNode; onComplete?: () => void }) {
    const value = useProcessJob(onComplete)
    return <ProcessJobContext.Provider value={value}>{children}</ProcessJobContext.Provider>
}

export function useProcessJobContext(): UseProcessJobReturn {
    const ctx = useContext(ProcessJobContext)
    if (!ctx) throw new Error('useProcessJobContext must be used within a ProcessJobProvider')
    return ctx
}
